import WoundExudate from './WoundExudate';

export default WoundExudate;
